module.exports = __webpack_public_path__ + "9575e50332c87ab1d5b381f8c93b1bb8.png";